import { Node } from '@tiptap/core';

export const MentionChip = Node.create({
  name: 'mention',
  inline: true,
  group: 'inline',
  atom: true,
  selectable: false,
  addAttributes() {
    return {
      token: { default: '' },
      label: { default: '' },
    };
  },
  parseHTML() {
    return [
      {
        tag: 'strong[data-token]',
        priority: 100,
        getAttrs: (element) => {
          if (!(element instanceof HTMLElement)) return false;
          return {
            token: element.getAttribute('data-token') || '',
            label: element.textContent || '',
          };
        },
      },
    ];
  },
  renderHTML({ node }) {
    return ['strong', { 'data-token': node.attrs.token }, node.attrs.label];
  },
});
